import React from 'react'
import { t, Trans } from '@lingui/macro'
import { observer } from 'mobx-react-lite'
import { Transaction } from '@odiupsk/up-api-client'
import { _ } from '../../common/utils/intl'
import {
  Button,
  ButtonLayout,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Grid,
  GridCol,
  Bar,
  BarItem,
  ReachDialog,
} from '../../common/ui-kit'
import { get } from '../../common/utils/get'
import { formatDateTime, formatMoney } from '../../common/utils/format'

export const TransactionDetailModal: React.FC<{
  transaction: Transaction
  close: () => void
}> = observer(({ transaction, close }) => {
  return (
    <ReachDialog size="xlarge" data-testid="transaction-detail-dialog" onDismiss={close}>
      <DialogHeader title={_(t`Detail transakcie`)} />
      <DialogContent>
        <Grid>
          <GridCol size={{ m: 6 }}>
            <Bar>
              <BarItem>
                <div>
                  <b>
                    <Trans>Suma</Trans>
                  </b>
                </div>
                <div className="text-color-grey-600">
                  {formatMoney(transaction.amount!)} {transaction.currency?.name}
                </div>
              </BarItem>
            </Bar>
          </GridCol>

          {get(transaction, 'main_description') && (
            <GridCol size={{ m: 6 }}>
              <Bar>
                <BarItem>
                  <div>
                    <b>
                      <Trans>Popis</Trans>
                    </b>
                  </div>
                  <div className="text-color-grey-600">{get(transaction, 'main_description')}</div>
                </BarItem>
              </Bar>
            </GridCol>
          )}

          <GridCol size={{ m: 6 }}>
            <Bar>
              <BarItem>
                <div>
                  <b>
                    <Trans>Dátum</Trans>
                  </b>
                </div>
                <div className="text-color-grey-600">{formatDateTime(transaction.date_date!)}</div>
              </BarItem>
            </Bar>
          </GridCol>

          {get(transaction, 'additional_description') && (
            <GridCol size={{ m: 6 }}>
              <Bar>
                <BarItem>
                  <div>
                    <b>
                      <Trans>Doplňujúce info</Trans>
                    </b>
                  </div>
                  <div className="text-color-grey-600">
                    {get(transaction, 'additional_description')}
                  </div>
                </BarItem>
              </Bar>
            </GridCol>
          )}

          <GridCol size={{ m: 6 }}>
            <Bar>
              <BarItem>
                <div>
                  <b>
                    <Trans>Typ transakcie</Trans>
                  </b>
                </div>
                <div className="text-color-grey-600">
                  {get(transaction, 'transaction_type', 'name')}
                </div>
              </BarItem>
            </Bar>
          </GridCol>

          {transaction.terminal_id && (
            <GridCol size={{ m: 6 }}>
              <Bar>
                <BarItem>
                  <div>
                    <b>
                      <Trans>POS terminál</Trans>
                    </b>
                  </div>
                  <div className="text-color-grey-600">{transaction.terminal_id}</div>
                </BarItem>
              </Bar>
            </GridCol>
          )}
        </Grid>
      </DialogContent>
      <DialogFooter>
        <ButtonLayout direction="horizontal" className="align-items-right">
          <Button onClick={close} data-testid="close-btn">
            <Trans>Zatvoriť</Trans>
          </Button>
        </ButtonLayout>
      </DialogFooter>
    </ReachDialog>
  )
})
